import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-geocode-results-modal',
    templateUrl: './geocode-results-modal.component.html',
    styleUrls: ['./geocode-results-modal.component.scss'],
})
export class GeocodeResultsModalComponent {
    constructor(public dialogRef: MatDialogRef<GeocodeResultsModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

    selectResult(result: any): void {
        this.dialogRef.close(result);
    }
}
